/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Prop_H2Inputs */

const es_cap_prop_h2 = /** @type {(inputs: Cap_Prop_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguna salida sin tu sí.`)
};

const gl_cap_prop_h2 = /** @type {(inputs: Cap_Prop_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningunha saída sen o teu si.`)
};

const en_cap_prop_h2 = /** @type {(inputs: Cap_Prop_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No trip without your yes.`)
};

/**
* | output |
* | --- |
* | "No trip without your yes." |
*
* @param {Cap_Prop_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_prop_h2 = /** @type {((inputs?: Cap_Prop_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Prop_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_prop_h2(inputs)
	if (locale === "en") return en_cap_prop_h2(inputs)
	return es_cap_prop_h2(inputs)
});